// @flow
'use strict';

import { connect } from 'react-redux';

import BotaoManifestacaoLote from './botao_manifestacao_lote';

export default connect<*, *, *, *, *, *>()(BotaoManifestacaoLote);
